<template>
  <UrlContent v-if="item.status != 'draft'" :item="item" :header="header" />
</template>

<script>
import UrlContent from './UrlContent.vue';

export default {
  name: 'OfferUrlContent',
  components: { UrlContent },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    header: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
